@let items = items$ | async;
@if (items | noEmpty) {
  <div class="p-6 w-full flex flex-col bg-white border border-black/10 rounded-xl gap-4">
    <div class="flex flex-row items-center gap-3">
      <svg-icon class="w-7 text-base-zoom-500" src="assets/icons/icon-rocket.svg"></svg-icon>
      <h3 class="text-md font-normal" translate>geral.atalhos</h3>
    </div>
    <div class="grid grid-cols-4 gap-4">
      @for (item of items; track $index) {
        @if (!!item.redirect) {
          <a class="flex flex-col cursor-pointer items-center gap-2" [href]="item.redirect" target="_blank">
            <div
              class="transition duration-200 rounded-full w-16 h-16 flex justify-center items-center border-white border-4 shadow-md/15"
              [ngClass]="item.style"
            >
              <svg-icon class="block" [ngClass]="item.iconStyle" [src]="item.icon | icon"></svg-icon>
            </div>
            <h3 class="text-center line-clamp-2">{{ item.title | translate }}</h3>
          </a>
        } @else if (item?.open) {
          <button
            [disabled]="item.load()"
            type="button"
            app-button
            class="flex cursor-pointer flex-col items-center gap-2 p-0!"
            (click)="onOpen(item)"
          >
            <div
              class="transition duration-200 rounded-full relative w-16 h-16 flex justify-center items-center border-white border-4 shadow-md/15"
              [ngClass]="item.style"
            >
              @if (item.load()) {
                <app-skeleton
                  [showLabel]="false"
                  baseStyle="rounded-full! bg-base-gray-light-400"
                  class="absolute top-0 left-0"
                ></app-skeleton>
              }
              <svg-icon class="block" [ngClass]="item.iconStyle" [src]="item.icon | icon"></svg-icon>
            </div>
            <h3 class="line-clamp-2 text-center">{{ item.title | translate }}</h3>
          </button>
        } @else {
          <a
            class="flex h-full cursor-pointer flex-col items-center gap-2"
            [routerLink]="routerLink(item)"
            [queryParams]="item.params"
          >
            <div
              class="transition duration-200 rounded-full w-16 h-16 flex justify-center items-center border-white border-4 shadow-md/15"
              [ngClass]="item.style"
            >
              <svg-icon class="block" [ngClass]="item.iconStyle" [src]="item.icon | icon"></svg-icon>
            </div>
            <h3 class="line-clamp-2 text-center">{{ item.title | translate }}</h3>
          </a>
        }
      }
    </div>
  </div>
}
